import Project from "../main.js";
import {Galleries} from "../components/galleries.js";

export class SelfActivities {
	constructor() {
		this.project = new Project()

		this.instances = {
			galleries: new Galleries()
		}
	}
}